<template>
  <section id="contact" class="contact-us">
    <div class="background-container">
      <!-- Contenedor para el fondo -->
    </div>
    
    <div class="content-container">
      <div class="lightbox">
        <div class="content">
          <div class="title-section">
            <h1 class="section-title">{{ translate('landing.contact_information', 'CONTACT') }} <br> {{ translate('landing.information', 'INFORMATION') }}</h1>
          </div>
          <div class="contact-info-grid">
            <div class="contact-item">
              <div class="contact-icon">
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                </span>
              </div>
              <div class="contact-details">
                <h2 class="contact-label">{{ translate('landing.email', 'EMAIL') }}</h2>
                  <div class="email-container">
                  <a href="#" @click.prevent="openGmail('contact@technopaws.co')" class="email-link" title="Send an email using Gmail"><p class="contact-value">contact@technopaws.co</p></a>
                  <button @click="copyEmail('contact@technopaws.co')" class="copy-button" title="Copy email to clipboard">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-      linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                  </button>
                  <span v-if="copied" class="copied-message">Copied!</span>
                </div>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                </span>
              </div>
              <div class="contact-details">
                <h2 class="contact-label">{{ translate('landing.phone', 'PHONE') }}</h2>
                <div class="phone-container">
                  <a href="tel:+18039784357" class="phone-link" title="Call this number"><p>+1 (803) 978-4357</p></a>
                  <button @click="copyPhone('+18039784357')" class="copy-button" title="Copy phone number to clipboard">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                  </button>
                  <span v-if="copiedPhone" class="copied-message">Copied!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Botón para volver al inicio -->
    <div class="back-to-top-container">
      <button @click="scrollToTop" class="cta-button back-to-top-button" title="back to top">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg>
        {{ translate('landing.back_to_top', 'back to top') }}
      </button>
    </div>
  </section>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'ContactUs',
  data() {
    return {
      copied: false,
      copiedPhone: false
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    
    openGmail(emailAddress) {
      // Configuración para el correo en inglés
      const subject = "Inquiry from Technopaws Website";
      const body = "Hello Technopaws Team,\n\nI would like to get more information about your services.\n\nThank you,";
      
      // Construir la URL para Gmail - esto abre el formulario de composición de Gmail en una nueva pestaña
      const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${emailAddress}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      
      // Abrir Gmail en una nueva pestaña
      window.open(gmailUrl, '_blank');
    },
    
    copyEmail(emailAddress) {
      // Copiamos la dirección al portapapeles
      navigator.clipboard.writeText(emailAddress)
        .then(() => {
          // Mostrar el mensaje "Copied!"
          this.copied = true;
          
          // Ocultamos el mensaje después de 2 segundos
          setTimeout(() => {
            this.copied = false;
          }, 2000);
        })
        .catch(err => {
          console.error('Could not copy to clipboard: ', err);
        });
    },
    
    copyPhone(phoneNumber) {
      // Copiamos el número de teléfono al portapapeles
      navigator.clipboard.writeText(phoneNumber)
        .then(() => {
          // Mostrar el mensaje "Copied!"
          this.copiedPhone = true;
          
          // Ocultamos el mensaje después de 2 segundos
          setTimeout(() => {
            this.copiedPhone = false;
          }, 2000);
        })
        .catch(err => {
          console.error('Could not copy to clipboard: ', err);
        });
    },
    goToHome() {
      this.$router.push('/home');
    }
  },
  setup() {
    const store = useStore()
    
    const translate = (key, fallback) => {
      const translations = store.state.translations
      const parts = key.split('.')
      
      let value = translations
      for (const part of parts) {
        if (value && value[part]) {
          value = value[part]
        } else {
          return fallback
        }
      }
      
      return typeof value === 'string' ? value : fallback
    }
    
    return {
      translate
    }
  }
}
</script>

<style scoped>
/* Usamos las variables globales de fuentes definidas en App.vue */
:root, body, * {
  font-family: var(--font-primary) !important;
}

:root {
  /* Variables globales si son necesarias */
}

.contact-us {
  position: relative;
  min-height: 80vh; /* Altura reducida */
  width: 100%;
  display: flex;
  color: white;
  overflow: hidden;
}

/* Contenedor para el fondo */
.background-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/technopawsImages/contact.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #09405c; /* Color de fondo que extiende la imagen */
  z-index: 1;
}

/* Contenedor para mantener el contenido centrado */
.content-container {
  width: 100%;
}
.content {
  display: flex;
  flex-direction: column;
  gap: 2rem; /* Espacio reducido */
/* Margen superior reducido */
  box-sizing: border-box;
  align-items: center;
}

.title-section {
  text-align: center;
  font-family: 'Montserrat', 'Arial', sans-serif;
}

.section-title {
  /* Usando la clase global h1 para tamaño y peso */
  color: #ffffff;
  letter-spacing: 4px;
}

.contact-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2.5rem;
  justify-content: center;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 1.2rem;
}

.contact-icon {
  background-color: rgba(255, 255, 255, 0.1);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.contact-label {
  /* Usando la clase global h2 para tamaño y peso */
  margin: 0;
  color: #07324a;
  letter-spacing: 1px;
}

.contact-value {
  /* Usando la clase global h4 para tamaño */
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
}

.email-container,
.phone-container {
  display: flex;
  align-items: center;
  position: relative;
}

.email-link,
.phone-link {
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.email-link:hover,
.phone-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.copy-button {
  background: none;
  border: none;
  padding: 0;
  margin-left: 0.5rem;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.copy-button:hover {
  color: #ffffff;
}

.copied-message {
  position: absolute;
  right: -15px;
  top: -20px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  opacity: 1;
  animation: fadeInOut 2s ease;
}

@keyframes fadeInOut {
  0% { opacity: 0; }
  20% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; }
}

.decoration-dots {
  position: absolute;
  bottom: 2rem;
  right: 3rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 0.5rem;
}

.dot {
  width: 8px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
}

.lightbox {
  background: rgba(225, 225, 225, 0.1);
  backdrop-filter: blur(8px);
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.lightbox .section-title,
.lightbox .contact-info-grid,
.lightbox .contact-item {
  color:  #07324a !important;
}

/* Media queries para móviles pequeños */
@media (max-width: 480px) {
  .contact-us {
    min-height: 40vh;
    padding: 3rem 0;
  }

  .content {
    padding: 1rem 1rem; /* Margen reducido significativamente */
    gap: 1rem;
  }
  
  .section-title {
    /* Tamaño viene de media query en App.vue para h1 */
    letter-spacing: 1px;
  }
  
  .contact-info-grid {
    gap: 0.8rem;
  }
  
  .contact-item {
    gap: 0.6rem;
  }
  
  .contact-icon {
    width: 30px;
    height: 30px;
  }
  
  .icon svg {
    width: 16px;
    height: 16px;
  }

  .contact-label {
    /* Tamaño viene de media query en App.vue para h2 */
  }
  
  .contact-value {
    /* Tamaño viene de media query en App.vue para h4 */
  }
  
  .back-to-top-button {
    margin-bottom: 15px;
  }
}

/* Estilos para el botón de volver al inicio */
.back-to-top-container {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  z-index: 10;
}

.back-to-top-button {
  background-color: #f5a361;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  padding: 0.75rem 1.5rem;
  border-radius: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  margin: 5rem
}

.back-to-top-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
}

@media (max-width: 768px) {
  .back-to-top-container {
    bottom: 1rem;
    right: 1rem;
  }
  
  .back-to-top-button {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    margin: 0.2rem;
  }
}
</style>
